module.exports = __webpack_public_path__ + "static/Apercu-LightItalic-e9c54ed53cbd974c968fbc9cf78d9c5b.svg";